import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  resetPrintSettingsApiService,
  type ResetPrintSettingsResponse,
} from "@/generated/fastapi";

export async function resetPrintSettings(
  accessToken: string | null | undefined,
) : Promise<ResetPrintSettingsResponse> {
  const response = await resetPrintSettingsApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
  });

  if (response.status !== 200 || !response.data) {
    throw new Error("Failed to reset print settings");
  }

  return response.data;
}
